import { render, staticRenderFns } from "./section-subtitle.vue?vue&type=template&id=1eeb059c&scoped=true&"
import script from "./section-subtitle.vue?vue&type=script&lang=js&"
export * from "./section-subtitle.vue?vue&type=script&lang=js&"
import style0 from "./section-subtitle.vue?vue&type=style&index=0&id=1eeb059c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeb059c",
  null
  
)

export default component.exports